import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UnifiedAuthService } from '../../services/unified-auth.service';

@Component({
    selector: 'app-expediente-modal',
    imports: [CommonModule],
    template: `
    @if (showModal) {
      <div class="modal-overlay">
        <div class="modal-content">
          <div class="icon-container">
            <span class="icon-warning">🚫</span>
          </div>
          <h1>Expediente Encerrado</h1>
          <p class="main-message">
            Seu horário de trabalho finalizou.<br>
            O acesso ao sistema foi interrompido temporariamente.
          </p>
          <div class="info-box">
            <p>Para regularizar seu acesso ou em caso de dúvidas, contate seu supervisor.</p>
          </div>
          <button class="btn-sair" (click)="sair()">
            Voltar para Login
          </button>
        </div>
      </div>
    }
    `,
    styles: [`
    /* --- FUNDO DA TELA (Overlay) --- */
    .modal-overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background-color: rgba(33, 37, 41, 0.95); /* Fundo bem escuro */
      backdrop-filter: blur(8px); /* Efeito de vidro fosco */
      z-index: 99999; /* ACIMA DE TUDO */
      display: flex;
      justify-content: center;
      align-items: center;
      animation: fadeIn 0.4s ease-out;
    }

    /* --- CAIXA DO MODAL --- */
    .modal-content {
      background: #ffffff;
      padding: 40px 30px;
      border-radius: 12px;
      width: 90%;
      max-width: 450px;
      text-align: center;
      box-shadow: 0 20px 50px rgba(0,0,0,0.5);
      border-top: 6px solid #e74c3c; /* Tarja vermelha de 'bloqueio' */
      position: relative;
      animation: slideUp 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275); /* Efeito de pulo */
    }

    /* --- ÍCONE --- */
    .icon-container {
      margin-bottom: 20px;
    }
    .icon-warning {
      font-size: 4rem;
      display: inline-block;
      animation: pulse 2s infinite;
    }

    h1 {
      color: #2c3e50;
      font-size: 1.8rem;
      font-weight: 700;
      margin-bottom: 15px;
      letter-spacing: -0.5px;
    }

    .main-message {
      color: #7f8c8d;
      font-size: 1.1rem;
      line-height: 1.6;
      margin-bottom: 25px;
    }

    /* --- CAIXA DE INFORMAÇÃO --- */
    .info-box {
      background-color: #f8f9fa;
      border: 1px solid #e9ecef;
      border-left: 4px solid #3498db; 
      padding: 15px;
      border-radius: 6px;
      font-size: 0.9rem;
      color: #555;
      margin-bottom: 30px;
      text-align: left;
    }
    .info-box p { margin: 0; }

    .btn-sair {
      background-color: #2c3e50;
      color: white;
      border: none;
      padding: 14px 30px;
      font-size: 1rem;
      border-radius: 8px;
      cursor: pointer;
      width: 100%;
      font-weight: 600;
      transition: all 0.2s ease;
      text-transform: uppercase;
      letter-spacing: 0.5px;
    }

    .btn-sair:hover {
      background-color: #34495e;
      transform: translateY(-2px);
      box-shadow: 0 5px 15px rgba(44, 62, 80, 0.3);
    }

    .btn-sair:active {
      transform: translateY(0);
    }

    @keyframes fadeIn {
      from { opacity: 0; }
      to { opacity: 1; }
    }

    @keyframes slideUp {
      from { 
        opacity: 0; 
        transform: translateY(40px) scale(0.9); 
      }
      to { 
        opacity: 1; 
        transform: translateY(0) scale(1); 
      }
    }

    @keyframes pulse {
      0% { transform: scale(1); }
      50% { transform: scale(1.1); }
      100% { transform: scale(1); }
    }
  `]
})
export class ExpedienteModalComponent {

  /** Signal de leitura (CD-safe): true quando o expediente foi encerrado. */
  get showModal(): boolean { return this.authService.expedienteEncerrado(); }

  constructor(private authService: UnifiedAuthService) {}

  sair() {
    this.authService.logout();
  }
}